import { RefObject } from 'react';
import { Chips } from 'primereact/chips';

interface FocusMultiSelectInputToEndOptions {
  chipsRef: RefObject<Chips | null>;
  containerRef: RefObject<HTMLDivElement | null>;
  scrollContainerSelector: string;
}

// Focuses the Chips input at the caret end and scrolls tokens into view.
// Deferred via requestAnimationFrame so focus runs after the current render.
export const focusMultiSelectInputToEndHandler = ({
  chipsRef,
  containerRef,
  scrollContainerSelector,
}: FocusMultiSelectInputToEndOptions): void => {
  requestAnimationFrame(() => {
    const input = chipsRef.current?.getInput?.() ?? null;

    if (!(input instanceof HTMLInputElement)) {
      return;
    }

    const inputValueLength = input.value.length;
    input.focus();
    input.setSelectionRange(inputValueLength, inputValueLength);

    // Keep the latest chips and caret visible when typing resumes from the end.
    const scrollContainer = containerRef.current?.querySelector(
      scrollContainerSelector
    );
    if (scrollContainer instanceof HTMLElement) {
      scrollContainer.scrollLeft = scrollContainer.scrollWidth;
    }
  });
};
